import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { DeleteDealershipsContainerProps } from "../../../../interfaces/containers";
import Delete from "../../../../pages/Profile/Concessionaire/Delete/Delete";
import { 
    getDealerships,
    deleteDealership, 
    cleanDeleteDealership 
} from "../../../../actions/dealerships";

interface DeleteWrapperProps {
    user: any;
    dealerships: any;
    getDealerships: Function;
    deleteDealership: Function;
    cleanDeleteDealership: Function;
    open: boolean;
    setOpen: Function;
    dealershipSelected: any;
    loading: boolean;
}

const DeleteWrapper = (props: DeleteWrapperProps) => {
    return <Delete {...props} />;
};

function mapStateToProps(state: DeleteDealershipsContainerProps) {
    return {
        user: state.auth.user,
        dealerships: state.profile.dealerships,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getDealerships,
        deleteDealership, 
        cleanDeleteDealership,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteWrapper);